<!-- 显示库存的表格 -->
<template>
  <Table
    style="margin-bottom: 20px"
    ref="tableRef"
    :showIndex="true"
    :data="tableData"
    :columns="tableColumns"
    :loading="loading"
    :total="tableTotal"
    :isLineSearch="true"
    :isSelect="true"
    rowKey="productInventoryId"
    height="calc(100vh - 275px)"
    :searchAttrName="['productName', 'productType', 'classification']"
    :isCreateSearch="false"
    :customParamsFun="() => ({ warehouse: data.warehouseId })"
    tableName="inventory"
    exportDataUrl="/productInventory/selectProductInventory"
    @onSearch="handleSearch"
  />
</template>

<script setup>
import Table from "@/components/Element/Table";
import { onMounted, ref, watch } from "vue";
import { getCustomTableCols } from "@/tableColumn";
import { listProductInventory } from "@/api/warehouse/inventory";

const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
  activeName: {
    type: String,
    default: "",
  },
});

const tableRef = ref(null);
const tableData = ref([]);
const loading = ref(false);
const tableTotal = ref(0);

const handleSearch = (data) => {
  loading.value = true;
  listProductInventory(data)
    .then((res) => {
      tableData.value = res.data;
      tableTotal.value = res?.pageParam?.totleInfo
        ? res.pageParam.totleInfo
        : 0;
    })
    .catch((err) => {})
    .finally(() => {
      loading.value = false;
    });
};

const tableColumns = getCustomTableCols([
  "productName",
  "productType",
  "eqptCode",
  "classification",
  "supplier",
  "supplierModel",
  "internalModel",
  "usageType",
  "productNum",
  "contractNo",
  "batchNo",
  "projectNo",
  "workContactNo",
  "inventoryStatus",
  "inventoryOperationType",
  "firstInWarehouseTime",
  "inWarehouseTime",
  "outWarehouseTime",
  "remarks",
  "operateTime",
  "operatorName",
]);

onMounted(() => {
  watch(
    () => props.activeName,
    (newVal) => {
      if (newVal === props.data.warehouseId) {
        // 更新数据
        tableRef.value && tableRef.value.onSearch();
      }
    },
    {
      immediate: true,
    }
  );
});
</script>

<style lang="scss" scoped></style>
